import { ThemeEvents } from '@theme/events';

const getSections = () =>
  Array.from(document.querySelectorAll('.shopify-section')).filter((s) =>
    s.querySelector('script[id^="VariantGalleryMap-"]')
  );

const getMap = (section) => {
  const script = section.querySelector('script[id^="VariantGalleryMap-"]');
  if (!script) return null;
  try {
    return JSON.parse(script.textContent || '{}');
  } catch {
    return null;
  }
};

const filterGallery = (section, variantId) => {
  const map = getMap(section);
  if (!map || !variantId) return;
  const raw = map[String(variantId)];
  let positions = [];
  if (Array.isArray(raw)) {
    positions = raw.map((x) => parseInt(x, 10)).filter((n) => Number.isFinite(n));
  } else if (typeof raw === 'string') {
    const nums = raw.match(/\d+/g) || [];
    positions = nums.map((x) => parseInt(x, 10)).filter((n) => Number.isFinite(n));
  }

  const gridItems = section.querySelectorAll('.media-gallery__grid li[ref="media[]"]');
  gridItems.forEach((el) => {
    const pos = parseInt(el.dataset.position || '0', 10);
    el.hidden = positions.length > 0 ? !positions.includes(pos) : true;
  });

  const slides = section.querySelectorAll('slideshow-slide[ref="slides[]"]');
  slides.forEach((el) => {
    const pos = parseInt(el.dataset.position || '0', 10);
    el.hidden = positions.length > 0 ? !positions.includes(pos) : true;
  });

  // Safety: if filtering hid everything (e.g., invalid positions), unhide all
  const visibleSlides = Array.from(slides).filter((el) => !el.hidden);
  const visibleGrid = Array.from(gridItems).filter((el) => !el.hidden);
  if (visibleSlides.length === 0 && visibleGrid.length === 0) {
    // No matching positions -> leave as-is without forcing all visible
    return;
  }

  // Ensure slideshow moves to first visible slide
  const firstVisibleIndex = visibleSlides.length
    ? Array.from(slides).indexOf(visibleSlides[0])
    : undefined;
  const mediaGallery = section.querySelector('media-gallery');
  if (
    mediaGallery &&
    mediaGallery.slideshow &&
    typeof mediaGallery.slideshow.select === 'function' &&
    typeof firstVisibleIndex === 'number' &&
    firstVisibleIndex >= 0
  ) {
    try {
      mediaGallery.slideshow.select(firstVisibleIndex, undefined, { animate: false });
    } catch {
      // noop
    }
  }
};

const getInitialVariantId = () => {
  const picker = document.querySelector('variant-picker');
  const json = picker?.querySelector('script[type="application/json"]')?.textContent;
  if (!json) return undefined;
  try {
    const v = JSON.parse(json);
    return v?.id?.toString();
  } catch {
    return undefined;
  }
};

if (typeof window !== 'undefined' && !window.__INLINE_VARIANT_GALLERY__) {
  window.addEventListener('load', () => {
    const id = getInitialVariantId();
    getSections().forEach((section) => filterGallery(section, id));
  });
  document.addEventListener(ThemeEvents.variantUpdate, (e) => {
    const id = e.detail?.resource?.id?.toString();
    requestAnimationFrame(() => {
      getSections().forEach((section) => filterGallery(section, id));
    });
  });
}
